import styled from 'styled-components';

export const EndpointProcessingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  height: 100%;
`;
